import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

export interface WeekStore {
  /** Lundi de la semaine courante au format ISO (YYYY-MM-DD) */
  currentWeekStart: string
  /** Change la semaine courante */
  setCurrentWeekStart: (isoDate: string) => void
  /** Remet la semaine courante à la semaine d'aujourd'hui */
  resetToCurrentWeek: () => void
}

/** Formatte une Date locale en YYYY-MM-DD sans passer par UTC */
export const toLocalISODate = (d: Date): string => {
  const y = d.getFullYear()
  const m = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  return `${y}-${m}-${day}`
}

/** Parse "YYYY-MM-DD" en Date locale (midi pour éviter les edge cases DST) */
export const parseLocalDate = (iso: string): Date => {
  const [y, m, d] = iso.split('-').map(Number)
  return new Date(y, m - 1, d, 12, 0, 0)
}

/**
 * Renvoie le lundi de la semaine en cours pour une date donnée.
 */
export const getMondayISO = (date: Date = new Date()) => {
  const d = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 12, 0, 0)
  const day = d.getDay() // 0=dim, 1=lun, ..., 6=sam
  const diff = day === 0 ? -6 : 1 - day
  d.setDate(d.getDate() + diff)
  return toLocalISODate(d)
}

export const useWeekStore = create<WeekStore>()(
  persist(
    (set) => ({
      currentWeekStart: getMondayISO(),
      setCurrentWeekStart: (iso) => set({ currentWeekStart: iso }),
      resetToCurrentWeek: () => set({ currentWeekStart: getMondayISO() })
    }),
    {
      name: 'week-store',
      storage: createJSONStorage(() => localStorage),
    }
  )
)
